<div class="cc-side-navigator-outer-toolbar side-navigator-outer-toolbar">
  <app-header
    #appHeader
    class="layout-header"
    [menuToggleEnabled]="enableSideMenu"
    [menuUserEnabled]="enableSideMenu"
    *ngIf="loggedIn()"
    (menuToggle)="processMenuToggle()"
  ></app-header>

  <dx-drawer
    position="before"
    [closeOnOutsideClick]="shaderEnabled"
    [openedStateMode]="menuMode"
    [revealMode]="menuRevealMode"
    [minSize]="minMenuSize"
    [shading]="false"
    [(opened)]="menuOpened"
    (openedChange)="onSidebarStateChanged($event)"
    class="layout-body"
  >
    <div class="side-navbar" *dxTemplate="let dataMenu of 'panel'">
      <app-side-navigation-menu
        #sideNavigationMenu
        *ngIf="enableSideMenu"
        [topItems]="topMenuItems"
        [bottomItems]="bottomMenuItems"
        [compactMode]="!menuOpened"
        [selectedItem]="selectedRoute"
        (selectedItemChanged)="navigationChanged($event)"
        (openMenu)="navigationClick()"
      ></app-side-navigation-menu>
    </div>

    <div class="content-wrapper" [ngClass]="{ 'sidebar-expanded': menuOpened }">
      <app-property-banner *ngIf="loggedIn()"></app-property-banner>
      <div class="content" [ngClass]="{ 'content-sm': isSmall }">
        <ng-content></ng-content>
      </div>
    </div>
  </dx-drawer>
</div>
